var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasPermission('permissions.print_qrcode'))?_c('el-button',{attrs:{"icon":"el-icon-printer","type":"warning","loading":_vm.loading},on:{"click":function($event){return _vm.onClick()}}},[_vm._v("Wydrukuj kod QR")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }